import { Cloudinary } from "@cloudinary/url-gen";
import { format, quality } from "@cloudinary/url-gen/actions/delivery";
import { name } from "@cloudinary/url-gen/actions/namedTransformation";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { smallBreakpoint } from "../theme/viewports";

export function generateVideoUrls(videoAssetId: string | null) {
  if (!videoAssetId) {
    return { mobile: "", desktop: "" };
  }

  const aspectRatio = 0.71;
  const leftColumnMaxWidth = 807;

  const cloudinary = new Cloudinary({
    cloud: { cloudName: "asos" },
  });

  const baseURL = "https://www.asos-video.com/video/upload/";

  const mobileCloudinaryURL = cloudinary
    .video(videoAssetId)
    .delivery(format("auto:video"))
    .delivery(quality("auto"))
    .namedTransformation(name("large_product_video"))
    .resize(fill().width(smallBreakpoint).aspectRatio(aspectRatio))
    .toURL();

  const desktopCloudinaryURL = cloudinary
    .video(videoAssetId)
    .delivery(format("auto:video"))
    .delivery(quality("auto"))
    .namedTransformation(name("large_product_video"))
    .resize(fill().width(leftColumnMaxWidth).aspectRatio(aspectRatio))
    .toURL();

  const mobileFullURL = `${baseURL}${mobileCloudinaryURL.replace(
    "https://res.cloudinary.com/asos/video/upload/",
    "",
  )}`;

  const desktopFullURL = `${baseURL}${desktopCloudinaryURL.replace(
    "https://res.cloudinary.com/asos/video/upload/",
    "",
  )}`;

  return {
    mobile: mobileFullURL,
    desktop: desktopFullURL,
  };
}
